import { UNSUPPORTED_MARK_TYPE } from './../../pm-converters/consts';
import type { Mark_Type } from './../../ricos-types/tiptap';
import { createRicosMarkExtension } from './../../plugin-commons';

export const unsupportedMark = createRicosMarkExtension<{
  HTMLAttributes: Record<string, string>;
}>({
  type: 'mark',
  groups: [],
  name: UNSUPPORTED_MARK_TYPE as Mark_Type,
  createExtensionConfig() {
    return {
      name: UNSUPPORTED_MARK_TYPE,
      addAttributes() {
        return {
          originalDecorationList: { default: [] },
        };
      },
      parseHTML() {
        return [
          {
            tag: 'unsupported_mark',
          },
        ];
      },
      renderHTML() {
        return ['span'];
      },
    };
  },
});
